import { api } from 'common/frontend/api';
import errorHandler from 'common/services/errorHandler';

export const isUniqueInventoryIdentifier = async (shopId: string, identifier: string) => {
	try {
		const inventoryItems = await api()
			.inventoryItems.get.where('shopId', '==', shopId)
			.whereArray('identifiers', 'array-contains', identifier)
			.get();
		if (!inventoryItems.length) return true;
		return false;
	} catch (e) {
		errorHandler.report(e);
		return false;
	}
};
